/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFailuresQueryResponse, IngestionStatusControllerGetFailuresQueryParams, IngestionStatusControllerGetFailures403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFailures";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetFailures } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetFailures";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetFailuresQueryKey = (params: IngestionStatusControllerGetFailuresQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/failures'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetFailuresQueryKey = ReturnType<typeof ingestionStatusControllerGetFailuresQueryKey>;
export function ingestionStatusControllerGetFailuresQueryOptions(params?: IngestionStatusControllerGetFailuresQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetFailuresQueryKey(params);
  return queryOptions<IngestionStatusControllerGetFailuresQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFailures403>, IngestionStatusControllerGetFailuresQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetFailures(params, config);
    }
  });
}

/**
 * @description Returns detailed information about failures across files, documents, and jobs, including error patterns and individual failure records. Requires System Administrator role.
 * @summary Get detailed failure analysis
 * {@link /api/v1/documents/ingestion-status/failures}
 */
export function useIngestionStatusControllerGetFailures<TData = IngestionStatusControllerGetFailuresQueryResponse, TQueryData = IngestionStatusControllerGetFailuresQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetFailuresQueryKey>(params?: IngestionStatusControllerGetFailuresQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetFailuresQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFailures403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetFailuresQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetFailuresQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetFailures403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}